<template>
  <div>
    <form
      class="variant-form"
      :class="{
        'is-invalid': isSubmitted && error,
      }"
      @submit.prevent="save"
    >
      <c-input
        ref="field"
        v-model="tmpValue"
        class="variant-form__field"
        :autofocus="true"
        :required="isSubmitted && error"
        :required-message="isSubmitted && error"
      />
      <div class="variant-form__actions">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Отменить',
            placement: 'top',
          }"
          class="variant-form__reset"
          :icon="{ icon: 'close', color: 'secondary' }"
          size="iconic"
          @click="reset"
        />
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Сохранить',
            placement: 'top',
          }"
          class="variant-form__save"
          :icon="{ icon: 'check', color: 'success' }"
          size="iconic"
          @click="save"
        />
      </div>
    </form>
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import { REQUIRED_ERROR } from "@/constants/errorFieldValues";

export default {
  components: { CButton, CInput },
  props: ["variant", "list"],
  data() {
    return {
      tmpValue: "",
      isSubmitted: false,
    };
  },
  computed: {
    normalizedValue() {
      return this.tmpValue.trim();
    },
    error() {
      if (!this.normalizedValue) return REQUIRED_ERROR;

      const inLowerCase = this.normalizedValue.toLowerCase();
      const isRepeatedValue = this.list.some((v) => {
        if (v === this.variant) return false;
        return v.text.toLowerCase() === inLowerCase;
      });

      if (isRepeatedValue) {
        return "Такое значение уже есть в справочнике";
      }

      return null;
    },
  },
  watch: {
    variant(v) {
      this.tmpValue = v.text;
    },
  },
  created() {
    this.tmpValue = this.variant.text;
  },
  methods: {
    save() {
      this.isSubmitted = true;
      if (this.error) return;

      this.variant.text = this.normalizedValue;
      this.$emit("close");
    },
    reset() {
      this.tmpValue = this.variant.text;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.variant-form {
  position: relative;

  &.is-invalid {
    padding-bottom: 24px;
  }

  &__actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
  }

  &__reset {
    margin-right: 12px;
  }

  /deep/ {
    .c-input-input {
      padding-right: 65px;
      font-size: 13px;
      text-overflow: ellipsis;
    }
  }
}
</style>
